import { TFunction } from 'react-i18next'
import { Input } from '../../../components'
import { colors } from '../../../constants';

interface ChannelsTableDisplayParams {
    t: TFunction<'translation', undefined>;
    bulkSelectionChannels: (e: React.MouseEvent, id: number) => void;
}

const channelsTableDisplay = ({ t, bulkSelectionChannels }: ChannelsTableDisplayParams) => [
    {
        onlyOnMobile: true,
        field: 'name',
        label: t('Name'),
        props: null,
        transform: null,
        width: '300px',
    },
    {
        onlyOnMobile: true,
        field: null,
        label: null,
        props: { align: 'right' },
        transform: ({ selected, id }: { selected?: boolean, id: number }) => (
            <Input
                type="check"
                value={selected}
                onChange={(e: React.MouseEvent) => bulkSelectionChannels(e, id)}
                borderColor={colors.bluedarkest}
                isInRow
            >
                {t('View')}
            </Input>
        ),
        width: '6%',
    },
    {
        field: 'name',
        label: t('Name'),
        props: null,
        transform: null,
        width: '84%',
    },
    {
        field: null,
        label: null,
        props: { align: 'right' },
        transform: ({ selected, id }: { selected?: boolean, id: number }) => {
            return (
            <Input
                type="check"
                value={selected}
                onChange={(e: React.MouseEvent) => bulkSelectionChannels(e, id)}
                borderColor={colors.bluedarkest}
                isInRow
            >
                {t('View')}
            </Input>
        )},
        width: '6%',
    },
]

export default channelsTableDisplay
